<app-berechnung-auswahl></app-berechnung-auswahl>
<!-- <app-analysis></app-analysis> -->
<app-groessen-eingabe></app-groessen-eingabe>
<router-outlet></router-outlet>



